import styled from "styled-components";

export const HeaderControls = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 40px;
`;
